import { Actions } from './organizations.actions'
import { fromJS } from 'immutable'
import * as organizationsTypes from './organizations.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
    results: 0,
  },
  createOrganization: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateOrganization: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function organizationsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case organizationsTypes.UPDATE_ORGANIZATION_REQUEST: {
      return state.setIn(['updateOrganization', 'isLoading'], true)
    }

    case organizationsTypes.UPDATE_ORGANIZATION_SUCCESS: {
      return state.setIn(['updateOrganization', 'isLoading'], false)
    }

    case organizationsTypes.UPDATE_ORGANIZATION_FAILURE: {
      return state.setIn(['updateOrganization', 'isLoading'], false)
    }

    case organizationsTypes.CREATE_ORGANIZATION_REQUEST: {
      return state.setIn(['createOrganization', 'isLoading'], true)
    }

    case organizationsTypes.CREATE_ORGANIZATION_SUCCESS: {
      return state.setIn(['createOrganization', 'isLoading'], false)
    }

    case organizationsTypes.CREATE_ORGANIZATION_FAILURE: {
      return state.setIn(['createOrganization', 'isLoading'], false)
    }

    case organizationsTypes.DELETE_ORGANIZATION_REQUEST: {
      return state
    }

    case organizationsTypes.DELETE_ORGANIZATION_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case organizationsTypes.DELETE_ORGANIZATION_FAILURE: {
      return state
    }

    case organizationsTypes.FETCH_ORGANIZATIONS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case organizationsTypes.FETCH_ORGANIZATIONS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case organizationsTypes.FETCH_ORGANIZATIONS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case organizationsTypes.FETCH_ORGANIZATION_REQUEST: {
      return state.setIn(['updateOrganization', 'isLoading'], true)
    }

    case organizationsTypes.FETCH_ORGANIZATION_SUCCESS: {
      return state
        .setIn(['updateOrganization', 'isLoading'], false)
        .setIn(
          ['updateOrganization', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case organizationsTypes.FETCH_ORGANIZATION_FAILURE: {
      return state.setIn(['updateOrganization', 'isLoading'], false)
    }

    case organizationsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case organizationsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
